import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { localUrl } from 'src/utils';

type Props = {
  cartIdParam: string | undefined;
  setCartId: (cartId: string) => void;
  pathname: 'get' | 'embed' | 'review' | 'receive' | 'make';
};

// match any lowercase letter
const REGEX = new RegExp(/[a-z]/);

export const useRedirectToUpperCase = ({
  cartIdParam,
  setCartId,
  pathname,
}: Props) => {
  let [searchParams] = useSearchParams();

  const navigate = useNavigate();

  // if cartId has any lowercase letters, redirect to the uppercase version
  return useEffect(() => {
    if (cartIdParam) {
      if (cartIdParam.length > 9) {
        // redirect to the make page with the cartId that looks like an item query
        window.location.href = localUrl(
          `/make/?vendor=amazon&keywords=${encodeURIComponent(cartIdParam)}`,
        );
      } else if (REGEX.test(cartIdParam)) {
        // redirect to the uppercase version of the cartId
        setCartId(cartIdParam.toUpperCase());

        navigate(
          {
            pathname: `/${pathname}/${cartIdParam.toUpperCase()}`,
            search: searchParams.toString(),
          },
          { replace: true },
        );
      } else {
        setCartId(cartIdParam);
      }
    } else {
      setCartId('');
    }
  }, [cartIdParam, navigate, searchParams, setCartId, pathname]);
};
